import driver from 'bootstrap'
driver('open')



// WEBPACK FOOTER //
// ./src/index.js